import { TenantDetalhe } from "core/features/tenants/typings/tenant";
import { useMutation } from "react-query";
import http from "infra/http";

function useSaveTenant(id?: string) {
  return useMutation(
    "/v1/tenants",
    (data: TenantDetalhe) =>
      id ? http.put(`/v1/tenants/${id}`, data) : http.post("/v1/tenants", data),
    { retry: false }
  );
}

export default useSaveTenant;
